import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Check } from 'lucide-react';
import { Button } from '../components/ui/button';

const MaisonsSurMesurePage = () => {
  const customHouses = [
    {
      id: 1,
      title: 'Ultra-contemporaine',
      image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800',
      tags: ['Luminosité', 'Souhaits esthétiques'],
      link: '/maisons-sur-mesure/ultra-contemporaine'
    },
    {
      id: 2,
      title: 'Le patio',
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800',
      tags: ['Contraintes terrain', 'Pièce dédiée'],
      link: '/maisons-sur-mesure/le-patio'
    },
    {
      id: 3,
      title: 'Aux couleurs du Sud',
      image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800',
      tags: ['Adaptation régionale', 'Souhaits esthétiques'],
      link: '/maisons-sur-mesure/aux-couleurs-du-sud'
    },
    {
      id: 4,
      title: 'En altitude',
      image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800',
      tags: ['Adaptation régionale', 'Souhaits esthétiques'],
      link: '/maisons-sur-mesure/en-altitude'
    },
    {
      id: 5,
      title: 'Le toit cathédrale',
      image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800',
      tags: ['Hauteur sous plafond', 'Luminosité'],
      link: '/maisons-sur-mesure/le-toit-cathedrale'
    },
    {
      id: 6,
      title: 'Un garage immense',
      image: 'https://images.unsplash.com/photo-1600573472592-401b489a3cdc?w=800',
      tags: ['Pièce dédiée', 'Vivre sa passion'],
      link: '/maisons-sur-mesure/un-garage-immense'
    },
    {
      id: 7,
      title: 'Un étage mezzanine',
      image: 'https://images.unsplash.com/photo-1600210491892-03d54c0aaf87?w=800',
      tags: ['Hauteur sous plafond', 'Souhaits esthétiques'],
      link: '/maisons-sur-mesure/un-etage-mezzanine'
    },
    {
      id: 8,
      title: 'Avec la piscine',
      image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800',
      tags: ['Adaptation régionale', 'Contraintes terrain'],
      link: '/maisons-sur-mesure/avec-la-piscine'
    },
    {
      id: 9,
      title: 'Le coin lecture',
      image: 'https://images.unsplash.com/photo-1600121848594-d8644e57abab?w=800',
      tags: ['Pièce dédiée', 'Vivre sa passion'],
      link: '/maisons-sur-mesure/le-coin-lecture'
    },
    {
      id: 10,
      title: 'La salle de sport',
      image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800',
      tags: ['Pièce dédiée', 'Vivre sa passion'],
      link: '/maisons-sur-mesure/la-salle-de-sport'
    },
    {
      id: 11,
      title: 'Une terrasse portée',
      image: 'https://images.unsplash.com/photo-1600607687644-c7171b42498b?w=800',
      tags: ['Contraintes terrain'],
      link: '/maisons-sur-mesure/une-terrasse-portee'
    },
    {
      id: 12,
      title: 'Avec bardage bois',
      image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800',
      tags: ['Contraintes terrain'],
      link: '/maisons-sur-mesure/avec-bardage-bois'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div
        className="relative h-96 bg-cover bg-center flex items-center"
        style={{
          backgroundImage: 'linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600)'
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-white">
            <div className="flex items-center text-sm mb-4">
              <Link to="/" className="opacity-90 hover:opacity-100">Accueil</Link>
              <ChevronRight className="w-4 h-4 mx-2" />
              <span>Maisons sur-mesure</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold">Votre maison sur-mesure et personnalisée</h1>
          </div>
        </div>
      </div>

      {/* Introduction */}
      <div className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Faites construire votre maison sur mesure et entièrement personnalisée</h2>
          <p className="text-lg text-gray-600 mb-4">
            Vous avez trouvé LE terrain de vos rêves et souhaitez maintenant construire une maison qui vous ressemble parfaitement ? Modernité, luminosité, grands espaces de vie… Vous avez déjà pensé aux grandes lignes de votre projet et souhaitez aujourd'hui les concrétiser ? Lancez-vous !
          </p>
          <p className="text-lg text-gray-600">
            MRTP SARL, c'est une véritable histoire de famille ou femmes et hommes œuvrent chaque jour pour faire de votre rêve une réalité. Depuis 1985, nous proposons à nos clients, un accompagnement personnalisé pour établir avec eux un logement sur mesure et adapté aux besoins de toute la famille.
          </p>
          <Button asChild className="mt-8 bg-[#c4d600] hover:bg-[#b0c200] text-gray-800 font-semibold">
            <Link to="/modeles">Découvrez nos modèles de maison</Link>
          </Button>
        </div>
      </div>

      {/* Custom Houses Grid */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {customHouses.map((house) => (
              <Link
                key={house.id}
                to={house.link}
                className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={house.image}
                    alt={house.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{house.title}</h3>
                  <div className="flex flex-wrap gap-2">
                    {house.tags.map((tag, index) => (
                      <span
                        key={index}
                        className="inline-flex items-center text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full"
                      >
                        <Check className="w-3 h-3 mr-1 text-[#c4d600]" />
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Section: Construire votre maison */}
      <div className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">Construire votre maison sur mesure</h2>
          <p className="text-lg text-gray-600 mb-4">
            Vous avez un projet de création 100 % originale pour votre future maison ? Vous êtes au bon endroit !
          </p>
          <p className="text-lg text-gray-600 mb-4">
            Parce que chaque mode de vie est différent, nous avons à cœur de proposer à tous nos clients un service d'accompagnement personnalisé pour concevoir ensemble une maison unique. Conseillers en architecte et équipe de conception vous aident à trouver les solutions de construction les plus adaptées à votre style de vie, vos goûts, et votre budget.
          </p>
          <p className="text-lg text-gray-600">
            Chaque terrain est unique et comporte des contraintes particulières. Nos spécialistes de la construction vous informent et vous orientent sur les dispositifs à mettre en place. Métier de passion, nous vous assurons liberté et sécurité pour mener à bien un projet complètement personnalisé.
          </p>
        </div>
      </div>

      {/* Section: Vos plans de maison */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Vos plans de maison</h2>
              <p className="text-gray-600 mb-4">
                Pour la construction de votre maison, il est primordial de bien réfléchir avant de valider chaque étape. Douche à l'italienne ou baignoire ? Menuiseries en bois ou en aluminium ? <strong>Agencement en L ou en U ?</strong> Nous vous accompagnons dans la réalisation de vos plans de maison et dans le choix des matériaux.
              </p>
              <p className="text-gray-600 mb-4">
                Observez, testez, comparez… Et faites votre choix parmi une large gamme de couleurs, textures, ou typologies de produits !
              </p>
              <p className="text-gray-600">
                Quoi de mieux que d'apprécier sur place la qualité des matériaux ? En plus, cette visite vous permet d'en savoir plus sur nos partenaires industriels français comme <strong>Atlantic, Bouyer, Jacob Delafon ou bien Bel'M et Millet.</strong>
              </p>
            </div>
            <div className="relative h-96 rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800"
                alt="Plans de maison"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Section: S'inspirer */}
      <div className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">S'inspirer des autres créations</h2>
          <p className="text-lg text-gray-600 mb-4">
            Depuis 1985, nous concevons des maisons uniques et adaptées aux besoins de nos clients. Laissez vivre votre imagination et inspirez-vous de nos dernières réalisations pour finaliser votre propre projet !
          </p>
          <p className="text-lg text-gray-600 mb-8">
            Examinez la demande du client, et les solutions que nous lui avons proposées. Peut-être avez-vous les mêmes problématiques ?
          </p>
          <p className="text-xl font-bold text-gray-800 mb-6">
            Réclamez la prestation que vous souhaitez ! Bardage en bois sur la façade d'une maison contemporaine, réalisation d'une terrasse portée, construction d'un toit cathédrale, aménagement d'un coin bibliothèque, sport, ou terrasse avec pergolas ? Tout est POSSIBLE !
          </p>
          <Button asChild className="bg-[#c4d600] hover:bg-[#b0c200] text-gray-800 font-semibold text-lg px-8 py-6">
            <Link to="/contact">Contactez-nous pour votre projet</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MaisonsSurMesurePage;